import { CalendarPlanThemeLink } from '@yandex-int/k-common';
import b from 'b_';
import cx from 'classnames';
import { Link, Text, useRouterPath, useStaticUrls } from 'platform-components';
import React from 'react';
import { useParams, useLocation } from 'react-router';

import { getPeriodLabel } from 'utils/get-period-label';

import './calendar-plan__theme-card.scss';

interface Props {
    className?: string;
    theme: CalendarPlanThemeLink;
    onLessonClick?: (lessonId: number) => void;
    onThemeNameClick?: (themeId: string) => void;
    disabled?: boolean;
}

export const CalendarPlanThemeCard = (props: Props) => {
    const { className, theme, disabled, onThemeNameClick } = props;
    const staticUrls = useStaticUrls();
    const { search } = useLocation();
    const { classId } = useParams<Record<string, string>>();
    const period = getPeriodLabel(theme.period.start_date, theme.period.end_date);
    const path = classId
        ? staticUrls.labClassLibrarySubjectCalendarPlanTheme
        : staticUrls.labLibrarySubjectCalendarPlanTheme;
    const link = `${useRouterPath(path, { calendarPlanThemeId: theme.theme.id })}${search}`;

    const handleThemeClick = () => {
        if (onThemeNameClick) {
            onThemeNameClick(theme.theme.id);
        }
    };

    return (
        <div className={cx('theme-card', className)}>
            <div className={b('theme-card', 'period')}>
                <Text size={Text.SIZE.S}>{period}</Text>
            </div>
            <Link disabled={disabled} isRouter onClick={handleThemeClick} theme={Link.THEME.STEALTHY} to={link}>
                <div className={b('theme-card', 'name', { disabled })}>
                    <Text size={Text.SIZE.XL}>{theme.theme.description}</Text>
                </div>
            </Link>
        </div>
    );
};
